import { Table as AntdTable, ConfigProvider, type TableProps } from 'antd'
import type { RefTable } from 'antd/es/table/interface'
import React from 'react'
import styled, { css } from 'styled-components'
import { borderRadius } from '../../config/antd-theme'

export const LEFT_FIXED_CELL_SELECTOR =
  'td.ant-table-cell.ant-table-cell-fix-left.ant-table-cell-fix-left-last'

function Table<RecordType extends object>(props: TableProps<RecordType>) {
  return (
    <ConfigProvider
      theme={{
        token: {
          // TODO double check later this radius override
          borderRadius
        }
      }}
    >
      <TableStyled<RecordType>
        pagination={{
          position: ['bottomCenter']
        }}
        {...props}
      />
    </ConfigProvider>
  )
}

const cssBorderRadius = css`
  .ant-table {
    border-radius: ${borderRadius}px;
  }

  .ant-table .ant-checkbox-inner {
    border-radius: 4px;
  }

  .ant-table-tbody > tr > td.ant-table-cell-row-hover:first-child {
    border-start-start-radius: inherit !important;
    border-end-start-radius: ${borderRadius}px !important;
  }

  .ant-table-tbody
    > tr:not(:last-child)
    > td.ant-table-cell-row-hover:first-child {
    border-start-start-radius: inherit !important;
    border-end-start-radius: inherit !important;
  }

  .ant-table-tbody > tr > td.ant-table-cell-row-hover:last-child {
    border-start-end-radius: inherit !important;
    border-end-end-radius: ${borderRadius}px !important;
  }

  .ant-table-tbody
    > tr:not(:last-child)
    > td.ant-table-cell-row-hover:last-child {
    border-start-end-radius: inherit !important;
    border-end-end-radius: inherit !important;
  }

  .ant-table-tbody > tr.ant-table-row.ant-table-row-selected > td:last-child {
    border-start-end-radius: inherit !important;
    border-end-end-radius: inherit !important;
  }

  .ant-table-tbody > tr.ant-table-row.ant-table-row-selected > td:first-child {
    border-start-start-radius: inherit !important;
    border-end-start-radius: inherit !important;
  }
`

const TableStyled = styled(AntdTable)`
  ${cssBorderRadius}

  ${LEFT_FIXED_CELL_SELECTOR} {
    padding-left: 24px;
  }
` as RefTable

export default Table
